import { AlertCircle, Check, Circle, Minus } from "lucide-react"
import { cn } from "@/lib/utils"
import type { JourneyStep, StepState } from "../../lib/careplan"

const DOT: Record<StepState, { cls: string; icon: React.ReactNode; word: string }> = {
  done: { cls: "bg-success border-success text-success-foreground", icon: <Check className="h-3 w-3" strokeWidth={3} />, word: "Done" },
  current: { cls: "bg-card border-primary text-primary", icon: <Circle className="h-2 w-2 fill-current" />, word: "Now" },
  overdue: { cls: "bg-destructive border-destructive text-destructive-foreground", icon: <AlertCircle className="h-3 w-3" strokeWidth={3} />, word: "Overdue" },
  upcoming: { cls: "bg-card border-muted-foreground/40 text-muted-foreground", icon: null, word: "Later" },
  na: { cls: "bg-muted border-muted text-muted-foreground", icon: <Minus className="h-3 w-3" />, word: "Not applicable" },
}

/** The case's 30 days, discharge to day 30: across the page on a wide screen, down it on a phone. */
export function JourneyStepper({ steps }: { steps: JourneyStep[] }) {
  return (
    <ol className="grid gap-3 md:grid-cols-7 md:gap-0" aria-label="The 30 days after discharge">
      {steps.map((s, i) => {
        const dot = DOT[s.state]
        return (
          <li key={s.key} className="relative flex gap-3 md:flex-col md:items-center md:gap-1.5 md:px-1 md:text-center">
            {i > 0 && (
              <span className="absolute left-[-50%] right-[50%] top-3 hidden h-px bg-border md:block" aria-hidden />
            )}
            <span
              className={cn("relative z-10 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2", dot.cls)}
              aria-hidden
            >
              {dot.icon}
            </span>
            <div className="min-w-0">
              <div className={cn("text-[13px] font-medium", s.state === "na" && "text-muted-foreground")}>
                {s.title}
                <span className="sr-only">: {dot.word}.</span>
              </div>
              <div className={cn("text-[11px] leading-snug", s.state === "overdue" ? "text-destructive" : "text-muted-foreground")}>
                {s.detail}
              </div>
            </div>
          </li>
        )
      })}
    </ol>
  )
}
